<template>
  <side-panel-inner class="idea">
    <template slot="actions">
      <base-button
        @click="addSystem"
        :primary="true"
        iconBefore="plus-circle"
      >{{editMode ? 'Edit' : 'Add'}}</base-button>
    </template>
    <h2 slot="header" class="c-panel__header-title">New System</h2>
    <loading v-if="loading"/>
    <div class="negative-margin" v-else>
      <form>
        <message type="error" v-if="showValidationMessage">
          <h3>Form Invalid</h3>
          <p>Form is invalid, please check and try again.</p>
          <ul>
            <li v-for="error in errors.items" :key="error.id">{{error.msg}}</li>
          </ul>
        </message>
        <form-field
          full-width
          required
          label="System Name"
          name="name"
          v-validate="'required'"
          data-vv-as="system name"
          :error="errors.first('name')"
          v-model="system.name"
        ></form-field>
      </form>
    </div>
  </side-panel-inner>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import UserHasPermission from "@/mixins/UserHasPermission";

export default {
  name: "SystemStatusAdd",

  data() {
    return {
      showValidationMessage: false,
      loading: false,
      editMode: false
    };
  },

  /**
   * TODO:
   * What we need to do is determine whether we are posting to a main comment or a reply
   * This should be similar in nature to the pages, so look at how that is done
   */
  methods: {
    addSystem() {
      const vm = this;
      this.$validator.validate().then(result => {
        if (!result) {
          vm.validationFailed = true;
        } else {
          const endpoint = this.editMode ? "systems/edit" : "systems/add";
          let payload = { name: this.system.name };

          if (this.editMode) {
            payload = (({ name, id }) => ({ name, id }))(this.system);
          }
          vm.$store.dispatch(endpoint, payload).then(() => {
            vm.$store.dispatch("CLOSE_PANEL");
            vm.$store.dispatch("systems/list", {forceUpdate: true})
          });
        }
      });
    }
  },

  computed: {
    ...mapState("systems", ["system"])
  },
  components: {},

  mixins: [UserHasPermission],

  mounted() {
    if (!this.$route.params.id) {
      this.$store.commit("systems/SET_SYSTEM", []);
    } else {
      this.$store.dispatch("systems/read", this.$route.params.id);
      this.editMode = true;
    }
  },

  created() {}
};
</script>


<style lang="scss" scoped>
</style>
